import { useEffect, useRef, useState } from "react";
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

interface ImgsScreenshot {
  listImg?: any[]
}

export const SliderMultiplier = (props: ImgsScreenshot) => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let slider1 = useRef(null);
  let slider2 = useRef(null);
  const listImg = props.listImg || [];

  useEffect(() => {
    setNav1(slider1.current)
    setNav2(slider2.current)
  },[slider1,slider2])

  return (
    <React.Fragment>
      <Slider asNavFor={nav2 as any} ref={slider1}>
        {
          listImg.map((csEl,index) => {
              return (
                <img src={csEl} alt={`${index}`} key={index} />
              )
          })
        }
      </Slider>
      <div className="thumb-paging">
      <Slider 
          asNavFor={nav1 as any}
          ref={slider2}
          slidesToShow={2}
          swipeToSlide={true}
          focusOnSelect={true}>
        {
          listImg.map((csEl,index) => {
              return (
                <img src={csEl} alt={`${index}`} key={index} />
              )
          })
        }
      </Slider>
      </div>
    </React.Fragment>
    )
}
